<template>
    <div v-if="calendar">
        <div class="card">
            <div class="card-header border-bottom">
                <h5 class="header-case mb-0">Calendar</h5>
            </div>
            <div class="card-body px-0">
                <div class="wrapper scrollbar dragscroll">

                    <!-- Desktop Layout -->
                    <div class="d-none d-md-flex row mx-0 calendar-row">
                        <div class="col table-col border-right px-0" v-for="(day, index) in calendar" :key="day.date">
                            <div class="table-h py-3 text-center cursor-pointer" @click="dayIndex = index"
                                :class="{ 'bg-primary-gradient': index == dayIndex }">
                                {{ day.label }}
                            </div>
                            <div class="content p-2">
                                <div class="row text-center">
                                    <InfoBox icon="far fa-user" :value="day.arrivals" tooltip="Arrivals" />
                                    <InfoBox icon="fa fa-door-open" :value="day.departures" tooltip="Departures" />
                                    <InfoBox icon="far fa-clock" :value="sumScheduled(day.scheduled)"
                                        tooltip="Scheduled Emails" />
                                    <InfoBox icon="far fa-envelope" :value="day.sent" tooltip="Sent" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Mobile Layout -->
                    <div class="d-md-none calendar-row">
                        <div class="col-12 px-0 mb-3 d-flex flex-column border-bottom pb-3"
                            v-for="(day, index) in calendar" :key="day.date">
                            <div class="table-h py-3 text-center cursor-pointer" @click="dayIndex = index"
                                :class="{ 'bg-primary-gradient': index == dayIndex }">
                                {{ day.label }}
                            </div>
                            <div class="content px-3 pt-2">
                                <div class="row text-center">
                                    <InfoBox icon="far fa-user" :value="day.arrivals" tooltip="Arrivals" />
                                    <InfoBox icon="fa fa-door-open" :value="day.departures" tooltip="Departures" />
                                    <InfoBox icon="far fa-clock" :value="sumScheduled(day.scheduled)"
                                        tooltip="Scheduled Emails" />
                                    <InfoBox icon="far fa-envelope" :value="day.sent" tooltip="Sent" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Survey Emails Section -->
                    <div class="border-top p-3">
                        <div class="mb-3 survey-section" v-for="rule in currentDay.scheduled" :key="rule.id">
                            <p>
                                <strong>Survey:</strong> {{ rule.rule.title }}
                            </p>
                            <table class="table table-responsive" v-if="rule.emails.length > 0">
                                <thead>
                                    <tr>
                                        <th>Email</th>
                                        <th>Type</th>
                                        <th>Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="email in rule.emails" :key="email.emailId">
                                        <td>{{ email.email }}</td>
                                        <td>{{ rule.rule.type | formatType }}</td>
                                        <td>{{ email.shouldBeSentAt }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <p class="readable-text" v-else>
                                No survey emails scheduled
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SurveysService from "../../services/surveys-service";

export default {
    components: {
        InfoBox: {
            props: ["icon", "value", "tooltip"],
            template: `
                <div class="col-3" data-toggle="tooltip" :title="tooltip">
                    <i :class="icon"></i>
                    <p class="mb-0">{{ value }}</p>
                </div>
            `
        }
    },
    computed: {
        currentDay() {
            return this.calendar[this.dayIndex];
        }
    },
    data() {
        return {
            calendar: null,
            dayIndex: 0,
            startDate: moment().format('YYYY-MM-DD')
        }
    },
    filters: {
        formatType(type) {
            return {
                'after_checkin': 'After Check-in',
                'after_checkout' : 'After Check-out',
                'before_checkin': 'Before Check In',
                'before_checkout': 'Before Check-out'
            }[type];
        }
    },
    mounted() {
        this.getCalendar();
    },
    methods: {
        async getCalendar() {
            const filters = { from: this.startDate };
            const data = await SurveysService.bookings.calendar(filters);
            this.calendar = data;
            this.$nextTick(() => {
                $('[data-toggle="tooltip"]').tooltip();
            });
        },
        sumScheduled(scheduled) {
            return scheduled.reduce((total, sched) => total + sched.emails.length, 0);
        }
    }
};
</script>

<style scoped>
.wrapper {
    overflow-x: hidden;
}
.table-h {
    font-size: 15px;
    font-weight: 900;
    color: #2c2d4a;
    background: #f8f8f8;
    border-bottom: solid 1px #e9eaec;
}
.content {
    border: 1px solid #e9eaec;
    border-radius: 5px;
}
</style>
